// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import { AMOUNT, COMPANY__ROLE, PROJECT_START, FEDERAL_STATE } from "./formFields";
import * as formatters from "../../utils/formatters";
import { mapOkpRole } from "./mappers";

type OkpProjectInfoProps = {
  initialValues: {
    [AMOUNT]: string,
    [COMPANY__ROLE]: string,
    [PROJECT_START]: string,
    [FEDERAL_STATE]: string
  },
  numberedWithDot?: boolean
};

const OkpProjectInfo = ({ initialValues, numberedWithDot }: OkpProjectInfoProps) => (
  <Section title="Vorhaben" reducedMargin numberedWithDot={numberedWithDot}>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: COMPANY__ROLE,
            caption: () => "Vorhabenart"
          }}
          displayValue={mapOkpRole}
        />

        <EditableField
          fieldControlProps={{
            name: PROJECT_START,
            caption: () => "Beginn des Vorhabens"
          }}
        />

        <EditableField
          fieldControlProps={{
            name: FEDERAL_STATE,
            caption: () => "Investitionsort"
          }}
        />
      </FormRow>

      <FormRow>
        <EditableField
          fieldControlProps={{
            name: AMOUNT,
            caption: () => "Investitionssumme"
          }}
          displayValue={formatters.formatDecimalCurrency}
        />

        <div />

        <div />
      </FormRow>
    </EditableForm>
  </Section>
);

OkpProjectInfo.defaultProps = {
  numberedWithDot: false
};

export default OkpProjectInfo;
